import gql from 'graphql-tag';

import ContentItemsFragment from './ContentItems.js';

export default gql`
  fragment BaseContentBundleFragment on BaseContentBundle {
    id
    layout
    data {
      title
      description
      link {
        title
        url
      }
      sponsor {
        name
        imageUrl
        messaging
      }
      ads {
        targeting {
          tags
          categories
          recipe
        }
        enabled
      }
      color
      kicker
    }
    items {
      ...ContentItemsFragment
    }
  }
  ${ContentItemsFragment}
`;
